import newGeneralParameterization from '@/components/generalParameterization/steps/generalParameterization.json'

// state generalParametrization
const state = {
  generalParameterizationSteps: newGeneralParameterization,
  generalParameterizationList: [],
  dataFile: null,
  message: {
    text: '',
    type: '',
    visible: false,
  },
}

// getters
const getters = {
  getGeneralParameterizationSteps(state) {
    return state.generalParameterizationSteps
  },
  getParameterizationList: (state) => () => {
    return state.generalParameterizationList
  },
  getParameterizationDataFile: (state) => () => {
    return state.dataFile
  },
}

// actions
const actions = {
  async getLastParameter({ commit, rootState }) {
    const url = `${process.env.VUE_APP_URL}/files/getLastParameter`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      return response.json()
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async getLastParameterTemplate({ commit, rootState }) {
    const url = `${process.env.VUE_APP_URL}/files/getLastParameterTemplate`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      return response.json()
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async uploadParameters({ commit, rootState }, data) {
    const url = process.env.VUE_APP_URL + '/files/uploadParameters'
    var formData = new FormData()
    formData.append('file', data)
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
        body: formData,
      })
      return response.json()
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async downloadLastFile({ commit, rootState }, data) {
    const url = `${process.env.VUE_APP_URL}/files/downloadFileLastParameters/${data.status}/${data.filename}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
}

// mutations
const mutations = {
  SET_GENERALPARAMETERIZATION_STEPS(state, newValue) {
    state.generalParameterizationSteps = newValue
  },
  SET_GENERALPARAMETERIZATION_LIST(state, newValue) {
    state.generalParameterizationList = newValue
  },
  SET_GENERALPARAMETERIZATION_DATAFILE(state, newValue) {
    state.dataFile = newValue
  },
  SET_GENERALPARAMETERIZATION_MESSAGE(state, newValue) {
    state.message = newValue
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
